import { useRuntimeConfig } from '#imports'

type CdnResolved = { provider: 'cloudinary' | undefined; src: string }

export function useCdnDiagnostics() {
  const config = useRuntimeConfig()
  const cloudBase: string = (config.public as any)?.cloudinaryBaseURL || 'https://res.cloudinary.com/ommi-shop/image/upload'

  const toAbsolute = (resolved: CdnResolved) => {
    if (resolved.provider === 'cloudinary' && resolved.src && !resolved.src.startsWith('http')) {
      return `${cloudBase}/${resolved.src}`
    }
    return resolved.src
  }

  const reportCdnError = async (context: string, slug?: string, resolved?: CdnResolved) => {
    try {
      if (!resolved) return
      const absolute = toAbsolute(resolved)
      // Best‑effort diagnostics; never throw
      // SSG-compatible: log locally without server API calls
      if (resolved.provider === 'cloudinary' && resolved.src) {
        // eslint-disable-next-line no-console
        console.warn('[cdn:error]', { context, slug, publicId: resolved.src, url: absolute })
      } else {
        // eslint-disable-next-line no-console
        console.warn('[cdn:error]', { context, slug, url: absolute || '(placeholder/local)' })
      }
    } catch {
      // swallow to avoid impacting UX
    }
  }

  return { reportCdnError }
}


